export default "/_next/static/media/play-store-image2.6af07eeb1e7b6168c3151fe48d648152.png";